import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const SEND_TO_ID = "AW-17456817899"; // Google Ads / gtag ID

/**
 * Tracks SPA route changes and sends page_view events to gtag.
 * Skips the first render to avoid double-counting since the initial
 * page_view is typically sent by gtag config on load.
 */
export default function RouteChangeTracker() {
  const location = useLocation();
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return; // avoid duplicate initial page_view
    }

    const gtag = (window as any)?.gtag as undefined | ((...args: any[]) => void);
    if (typeof gtag !== "function") return;

    try {
      gtag('config', SEND_TO_ID, {
        page_title: document.title,
        page_location: window.location.href,
        page_path: `${location.pathname}${location.search}`,
      });
    } catch (e) {
      // silent fail
    }
  }, [location.pathname, location.search]);

  return null;
}
